import { ListItem, ListItemProps, ButtonBaseProps } from "@mui/material";

type DynamicButtonListItemProps = ListItemProps<"li"> & ButtonBaseProps<"div"> & { button?: boolean };

export const ListItemAsButton = (props: DynamicButtonListItemProps) => {
  const { button, children, ...rest } = props;

  if (button === true) {
    return (
      <ListItem button {...rest}>
        {children}
      </ListItem>
    );
  }
  return <ListItem {...rest}>{children}</ListItem>;
};
